"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- COPY SNIPPET FIELD : DEFINITION --------------- ++++++++++ */

var _default2 = {
  name: 'CopySnippetField',
  props: {
    title: {
      type: 'string',
      default: 'Title'
    },
    description: {
      type: 'string',
      default: 'This is the description of this code snippet.'
    },
    codeSnippet: {
      type: 'string',
      default: '<!--default code snippet-->'
    },
    link: {
      type: 'object',
      default: {
        name: 'link',
        text: 'Link',
        url: 'https://insticator.com'
      }
    },
    handleLinkClick: {
      type: 'function',
      default: function _default() {
        return console.log('link clicked');
      }
    }
  }
};
exports.default = _default2;